export const m9l0Solution = `%lang starknet

// Hints are the Cairo way to defer part of the program execution to an external program
// Memory can be accessed and assigned inside a hint by using variables identifiers.
// e.g., inside a hint variable 'a' is accessed through 'ids.a'

// do not modify code on this line or above

func basic_hint() -> (value : felt) {
    alloc_locals;
    local res;
    %{ ids.res = 42 %}
    return (value=res);
}

// do not modify code on this line or below

@external
func test_basic_hint{syscall_ptr : felt*}() {
    let (value) = basic_hint();
    assert 41 = value - 1;
    return ();
}`;
